<template>
  <div>
    <el-button class="newAdd" @click="openDialog">商务归属修改</el-button>
    <el-dialog
      title="商务归属修改"
      :visible.sync="moveDialogVisible"
      width="40%"
      center
      @close="clear"
    >
      <el-form :model="form" :rules="rules" ref="form">
        <el-form-item
          label="顶级合伙人UID"
          :label-width="formLabelWidth"
          prop="userId"
        >
          <el-input
            v-model="form.userId"
            class="searchIpt"
            autocomplete="off"
          ></el-input>
        </el-form-item>
        <el-form-item
          label="商务ID"
          :label-width="formLabelWidth"
          prop="inviteBy"
        >
          <el-input
            v-model="form.inviteBy"
            class="searchIpt"
            autocomplete="off"
          ></el-input>
        </el-form-item>
      </el-form>
      <span slot="footer" class="dialog-footer">
        <el-button size="small" type="primary" @click="add">添加</el-button>
        <el-button size="small" @click="clearFiled">重置</el-button>
      </span>
      <!-- <span slot="footer" class="dialog-footer">
    <el-button @click="centerDialogVisible = false">取 消</el-button>
    <el-button type="primary" @click="centerDialogVisible = false">确 定</el-button>
  </span> -->
    </el-dialog>
  </div>
</template>

<script>
import { mapActions } from 'vuex'
import moment from 'moment'
export default {
  data() {
    return {
      moveDialogVisible: false,
      detailInfo: null,
      isAct: false,
      form: {
        inviteBy: '',
        userId: '',
      },
      formLabelWidth: '140px',
      rules: {
        userId: [{ required: true, message: '请输入UID', trigger: 'blur' }],
        inviteBy: [
          { required: true, message: '请输入商务ID', trigger: 'blur' },
        ],
        // rate: [{ required: true, message: "请输入比例", trigger: "blur" }],
        otcRate: [
          { required: true, message: '请输入otcRate返佣比例', trigger: 'blur' },
        ],
      },
    }
  },
  methods: {
    ...mapActions('partnerList', ['updateAffaires', 'getUserData']),

    openDialog() {
      this.moveDialogVisible = true
    },

    add() {
      this.$refs['form'].validate((valid) => {
        if (valid) {
          this.updateAffaires(this.form).then((res) => {
            if (res.code == 0) {
              if (res.data.code == 0) {
                this.$message.success('添加成功')
                this.$emit('refresh')
                this.clear()
              } else {
                this.$message.error(res.data.msg || '添加失败')
                this.clear()
              }
            } else {
              this.$message.error('添加失败')
              this.clear()
            }
          })
        } else {
          console.log('error submit!!')
          return false
        }
      })
    },
    clearFiled() {
      this.$refs['form'].resetFields()
    },
    clear() {
      this.moveDialogVisible = false
      this.isAct = false
      this.detailInfo = null
      this.$refs['form'].resetFields()
    },
  },
}
</script>

<style lang="less" src="../../../../styles/button.less" scoped>
.content {
  // border: 1px solid #f5f6f7;
  padding: 20px;
  width: 100%;
  height: 200px;
  .up {
    border: 1px solid #f5f6f7;
    width: 100%;
    height: 50%;
    display: flex;
  }
  .down {
    border: 1px solid #f5f6f7;
    width: 100%;
    height: 50%;
    display: flex;
    justify-content: space-around;
    align-items: center;
  }
  .item {
    border-right: 1px solid #f5f6f7;
    display: flex;
    width: 50%;
    height: 100%;
    justify-content: center;
    align-items: center;
    .ipt {
      width: 90%;
    }
  }
}
.btn1 {
  display: flex;
  justify-content: center;
  width: 300px;
  margin: 0 auto;
}
</style>
